<template>
    <loading v-if="loading" message="Загружаем историю..."></loading>
    <div v-else class="steamline">
        <div class="sl-item" v-for="log in logs">
            <div class="sl-left"><img class="img-circle" :src="getAvatarPath(log.user.avatar)"></div>
            <div class="sl-right">
                <div>
                    <router-link v-if="user.isAdmin" :to="{ name: 'ViewProfile', params: { id: log.user.id }}">{{log.user.fullname}}</router-link>
                    <span v-else>{{log.user.fullname}}</span>
                    <span class="sl-date">{{log.diffForHumans}} ({{log.date}} в {{log.time}})</span></div>
                <div class="desc">{{log.text}}</div>
            </div>
        </div>
    </div>
</template>
<script>
  import gql from 'graphql-tag'
  import { storageUrl } from './../../config'
  import { mapState } from 'vuex'

  const getLogsQuery = gql`
    query getLogs ($objectId: Int!) {
        logs (objectId: $objectId, objectType: "order"){
            id,
            diffForHumans,
            text,
            date,
            time,
            user{
                id,
                fullname,
                avatar
            }
        }
    }`

  export default {
    name: 'order-history',
    props: ['order'],
    data () {
      return {
        loading: false
      }
    },
    computed: mapState({
      user: state => state.globalStore.user
    }),
    apollo: {
      logs: {
        query: getLogsQuery,
        variables () {
          return {
            objectId: this.order.id
          }
        },
        watchLoading (isLoading) {
          this.loading = isLoading
        },
        fetchPolicy: 'network-only'
      }
    },
    methods: {
      /**
       * Метод возвращает полный пут к аватарке пользователя
       * @param path
       * @return {string}
       */
      getAvatarPath (path) {
        return storageUrl + path
      }
    }
  }
</script>



// WEBPACK FOOTER //
// OrderHistory.vue?a1de537e